import { Suspense, useEffect, useRef, useState } from "react";

// Re-scroll al #id una vez montada la sección (el layout de arriba puede haber cambiado).
export function HashScrollFix({ id }) {
  useEffect(() => {
    if (window.location.hash !== `#${id}`) return;
    const go = () => document.getElementById(id)?.scrollIntoView({ block: "start" });
    const timers = [setTimeout(go, 60), setTimeout(go, 600), setTimeout(go, 1400)];
    return () => timers.forEach(clearTimeout);
  }, [id]);
  return null;
}

// Monta una sección de la Home recién cuando se acerca al viewport (o si la URL apunta a su #id).
export default function LazySection({ id, minHeight = 600, children }) {
  const ref = useRef(null);
  const [show, setShow] = useState(() => !!id && window.location.hash === `#${id}`);
  useEffect(() => {
    if (show) return;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setShow(true), { rootMargin: "600px 0px" });
    io.observe(ref.current);
    const onHash = () => id && window.location.hash === `#${id}` && setShow(true);
    window.addEventListener("hashchange", onHash);
    return () => { io.disconnect(); window.removeEventListener("hashchange", onHash); };
  }, [show, id]);
  const placeholder = <div id={show ? undefined : id} ref={ref} style={{ minHeight }} />;
  if (!show) return placeholder;
  return (
    <Suspense fallback={<div style={{ minHeight }} />}>
      {children}
      {id && <HashScrollFix id={id} />}
    </Suspense>
  );
}
